import AdminLayout from "@/layout/admin";
import Loader from "@quest/ui/components/loader";
import { Suspense } from "react";
import { RouteObject } from "react-router-dom";
import ErrorPage from "@quest/shared/error-page";
import { lazy } from "react";

// Import feature routes
import { dashboardRoutes } from "./admin/dashboard-routes";
import { studentsRoutes } from "./admin/students-routes";
import { membersRoutes } from "./admin/members-routes";
import { parentsAdminRoutes } from "./admin/parents-routes";
import { assignmentsRoutes } from "./admin/assignments-routes";
import { assignmentResultsRoutes } from "./admin/assignment-results-routes";
import { announcementsRoutes } from "./admin/announcements-routes";
import { subjectsRoutes } from "./admin/subjects-routes";
import { documentsRoutes } from "./admin/documents-routes";
import { foldersRoutes } from "./admin/folders-routes";
import { journalRoutes } from "./admin/journal-routes";
import { passportRoutes } from "./admin/passport-routes";
import { timeSlotsRoutes } from "./admin/time-slots-routes";
import { icaresRoutes } from "./admin/icares-routes";

const FallbackLoader = () => {
  return <Loader />;
};

// Error pages
const NotFoundPage = lazy(() => import("@/features/not-found/auth-failed"));
const ForbiddenPage = lazy(() => import("@/features/not-found/forbidden"));
const PageNotFoundPage = lazy(
  () => import("@/features/not-found/page-not-found")
);

export const adminRoutes: RouteObject[] = [
  {
    path: "/admin",
    children: [
      {
        path: "/admin",
        element: (
          <Suspense fallback={<FallbackLoader />}>
            <AdminLayout />
          </Suspense>
        ),
        errorElement: <ErrorPage />,
        children: [
          ...dashboardRoutes,
          ...studentsRoutes,
          ...membersRoutes,
          ...parentsAdminRoutes,
          ...assignmentsRoutes,
          ...assignmentResultsRoutes,
          ...announcementsRoutes,
          ...subjectsRoutes,
          ...documentsRoutes,
          ...foldersRoutes,
          ...journalRoutes,
          ...passportRoutes,
          ...timeSlotsRoutes,
          ...icaresRoutes,
        ],
      },
      {
        path: "/admin/not-found",
        element: <NotFoundPage />,
      },
      {
        path: "/admin/forbidden",
        element: <ForbiddenPage />,
      },
      {
        path: "*",
        element: <PageNotFoundPage />,
      },
    ],
  },
];
